import Form from '../../form';
import Vue from "vue";


let app = new Vue({
    el: '#vip-send',

    mounted: function () {
        let vm = this;
        $("#app-vipbooking").on('focusout', function (event) {
            let elemName = event.target.getAttribute('name');
            let elemType = event.target.getAttribute('type');
            if (event.target.classList.contains('error')) {
                event.target.classList.remove('error');
                vm.form.errors.clear(elemName);
            }
            if (elemType == 'text' || event.target.tagName.toLowerCase() == 'textarea') {
                console.log(elemName);
                if (elemName != 'email' && (typeof app.form[elemName] !== 'undefined')) {
                    app.form[elemName] = app.form[elemName].toUpperCase();
                }
            }
            if(event.target.classList.contains('needcheck')) {
                var i = app.needcheck.indexOf(elemName);
                if(i > -1) {
                    app.needcheck.splice(i,1);
                }

            }
        });


    },

    data: {
        form: new Form({
            id: '',
            uid: '',
            airport: '',
            name: '',
            traveltype: '',
            carReg: '',
            amexValetService: false,
            clientarrivingby: 'nocar',
            vpsbooking: null,
            crvbooking: null,
            donext: null,
            nextText: '',
            apmailurl: null,
            airportemail: '',
            state: '',
            mailSuccess: false,

        }),
        needcheck: [],

    },
    computed: {

    },
    watch: {

        submitting() {
            if (this.submitting) {
                $("#overlay").show();
            } else {
                $("#overlay").hide();
            }
        },

    },

    components: {},
    methods: {
        init(appdata) {
            this.form.init(appdata.formdata);
            this.needcheck = [];
            this.loadhistory(this.form.id, 'vip', 'airport_booking', '#aphistory')
        },
        needCheck(name) {

            if(_.indexOf(this.needcheck, name)!==-1) {
                console.log('needcheck');
                return 'needcheck';
            } else {
                return '';
            }
        },
        nextAction() {
            let url = null;
            let type = '';
            switch (this.form.donext) {
                case 'makevps':
                    url = this.form.vpsbooking;
                    type = 'VPS';
                    break;
                case 'makecrv':
                    url = this.form.crvbooking;
                    type = 'CRV';
                    break;
                case 'showvps':
                    location.href = this.form.vpsbooking;
                    break;
                case 'showcrv':
                    location.href = this.form.crvbooking;
                    break;
                default:
                    type = '';

            }

            axios.get(url).then((result) => {
                if(result.data.message) {
                    swal({
                        type: 'error',
                        text: result.data.message
                    });
                    return;
                }
                if(result.data.target) {
                    swal({
                        type: 'info',
                        text: type + window.translations.booking_created_info[window.locale]
                    });
                    if(type=='VPS') {
                        this.form.vpsbooking = result.data.target;
                        this.form.donext = 'showvps';
                        this.form.nextText = window.translations.booking_created_next_vps[window.locale];
                    } else if(type=='CRV') {
                        this.form.crvbooking = result.data.target;
                        this.form.donext = 'showcrv';
                        this.form.nextText = window.translations.booking_created_next_crv[window.locale];
                    }

                }
            })
        },
        sendMail() {
            var url = this.form.apmailurl;
            var mailAdr = this.form.airportemail;
            var bookingid = this.form.id;
            var token = $("input[name=_token]").val();
            if (!window.helpers.validateMail(mailAdr)) {
                swal({
                    type: 'error',
                    title: window.translations.send_invalid_title[window.locale],
                    html: '<div class="alert alert-danger" role="alert">'+window.translations.send_email_invalid_text[window.locale]+'</div>',
                });
                return;
            } else {
                if($("#sendapmail").hasClass("btn-success")) {
                    return;
                }
                axios.post(url, {to: mailAdr, id: bookingid, _token: token})
                    .then((result) => {
                        console.log(result);
                        if (result.data.error) {
                            this.form.mailSuccess = false;
                        } else {
                            this.form.mailSuccess = true;
                        }
                        this.loadhistory(bookingid, 'vip', 'airport_booking', '#aphistory')
                        swal({
                            type: 'info',
                            title: "E-Mail",
                            html: result.data.message,
                        }).then(()=>{
                            //make vps or crv
                            if(this.form.donext === 'makevps' || this.form.donext === 'makecrv') {
                               this.nextAction();
                            }
                        });

                    }
                );
            }
        },

        loadhistory(id, type, mailtype, target) {
            $.post('/bookingmailhistory', {
                id: id,
                type: type,
                mailtype: mailtype
            }, function (res) {
                console.log($(target));
                $(target).html(res.table);
            });
        }








    }
});


export default app;